class BetHistoryApiService {
  constructor(HttpService) {
    'ngInject';

    this.HttpService = HttpService;
  }

  getSettledBetSummary(url) {
    return this.HttpService.get(url); 
  }

  getBetList(url) {
    return this.HttpService.getNonAsync(url); 
  }
}

export default BetHistoryApiService;


// WEBPACK FOOTER //
// ./client/app/pages/customer/bethistory/service/api.service.js